import React, { useContext, useState } from "react";
import AuthLayout from "../../components/layouts/AuthLayout";
import { validateEmail, validatePassword } from "../../utils/helper";
import ProfilePhotoSelector from "../../components/Inputs/ProfilePhotoSelector";
import Input from "../../components/Inputs/Input";
import { Link,  useNavigate } from "react-router-dom";
import axiosInstance from "../../utils/axiosInstance";
import { API_PATHS } from "../../utils/apiPaths";
import { UserContext } from "../../context/UserContext";
import uploadImage from "../../utils/uploadImage";

const SignUp = () => {
  const [profilePic, setProfilePic] = useState(null);
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
 const [success, setSuccess] = useState(false);
  const [adminInvitToken, setAdminInvitToken] = useState("");
  const [error, setError] = useState(null);
   const {updateUser} = useContext(UserContext);   
   const navigate = useNavigate();
  //Handle form submission
  const handleSignup =  async(e) => {
    e.preventDefault();

     let profileImageUrl = ""

    if (!fullName) {
      setError("entrez un nom complet.");
      return;
    }

    if (!validateEmail(email)) {
      setError("entrez un email valide.");
      return;
    }

    if (!validatePassword(password)) {
      setError(
        "entrez un mot de passe avec une lettre majuscule,minuscule,un chiffre et un caractere speciale requis pour le mot de passe"
      );
      return;
    }

    setError("");
     //signup call api
    try {
      //Upload image 
      if(profilePic){
        const imgUploadRes = await uploadImage(profilePic);
         profileImageUrl = imgUploadRes.imageUrl; // Assuming the response contains the image URL

      }
      const response = await axiosInstance.post(API_PATHS.AUTH.REGISTER,{
        name:fullName,
        email,
        password,
        profileImageUrl,
        adminInvitToken
      });
      const { token, role } = response.data;
      if(token){
        localStorage.setItem("token", token);
        updateUser(response.data);
        // Redirection based on role
        navigate(role === "admin" ? "/admin/dashboard" : "/user/dashboard");
      }
    } catch (error) {
      if (error.response && error.response.data.message) {
        setError(error.response.data.message);
      }else{
        setError("Une erreur s'est produite lors de l'inscription, veuillez réessayer.");
        setSuccess(false)
      }
    }
   
  };
  return (
    <AuthLayout>
      <div className="lg:w-[100%] h-auto md:h-full flex flex-col justify-center">
        <h3 className="text-xl font-semibold text-black">Creer un compte</h3>
        <p className="text-xs text-slate-700 mt-[5px] mb-6">
          Remplissez les informations ci-dessous pour créer un compte.
        </p>

        <form onSubmit={handleSignup}>
          <ProfilePhotoSelector image={profilePic} setImage={setProfilePic} />

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Input
               value={fullName}
               onChange={({target})=>setFullName(target.value)}
               label="Nom complet"
               placeholder="john"
               type='text'
               />
                <Input
            value={email}
            onChange={({ target }) => setEmail(target.value)}
            label="email"
            placeholder="john@example.com"
            type="text"
          />
          <Input
            value={password}
            onChange={({ target }) => setPassword(target.value)}
            label="mot de passe"
            placeholder="minimum 8 carateres"
            type="password"
          />
            <Input
            value={adminInvitToken}
            onChange={({ target }) => setAdminInvitToken(target.value)}
            label="TOKEN D'invitation ADMIN"
            placeholder="code a 5 chiffres"
            type="text"
          />

          {error && <p className="text-red-500 text-xs pb-2.5 ">{error}</p>}
          <button type="submit" className="btn-primary disabled:opacity-50"  disabled={!email || !password}>
            s'enregistrer
          </button>

          <p className="text-[13px] text-slate-800 mt-3">
            Vous avez un compte?{""}
            <Link className="font-bold text-blue-600 underline" to="/">se connecter</Link>
          </p>
          </div>
        </form>
      </div>
       {success && <div className="lg:w-[100%] h-auto md:h-full flex flex-col justify-center items-center text-center">
          <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded mb-4">
            <h3 className="text-xl font-semibold mb-2">Inscription réussie !</h3>
            <p className="text-sm">Votre compte a été créé avec succès.</p>
          </div>
          
          <div className="flex flex-col gap-3 mt-4">
            <Link 
              to="/" 
              className="btn-primary text-center"
            >
              Se connecter
            </Link>
            
          
          </div>
        </div>}
    </AuthLayout>
  );
}

export default SignUp;

